import { Component, OnInit, Input,Output, EventEmitter } from '@angular/core';
import { SharedService } from  '../.././shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../.././shared/base.component';
import { DatePipe } from '@angular/common';
import { TechnicianJobService } from'../../technician/technician-jobs/technician-jobs.service';
import { LoaderService } from  '../.././shared/loader.service';
import { Logo, PrintPreview, PrintPreviewModel, JobDetailMaster, JobAppointMent, WoJobTaskDetails, SpecialService,SigNature, Company, EquipmentEntity, EmailJobAttachement, SendEmailJob ,EmailLogDetails} from '../../technician/technician-jobs/technician-jobs.models';
import { PartRequestEntity, WoSLAHistory,SmsLogReceived } from '../../work-order/work-order-models';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Severities } from '../.././shared/shared.model';
import { CapitalizeFirstPipe } from   '../.././shared/pipes/custom-pipes.pipe';
// import { multipleEmailValidator } from '../custom-validators/custom-validator.directive';
import { emailValidator, compareValidator } from '../.././shared/custom-validators/custom-validator.directive';

@Component({
    selector: 'email-popupreecived',
    templateUrl: 'email-popup.html'
})
export class viewEmailComponent extends BaseComponent implements OnInit {
     @Output() done = new EventEmitter();
    //@Input() job: any;
    
    //@Input() LogId: number;
    companyId: number;
    userId: number;
    equipmentEntity: EquipmentEntity[] = [];
    emailLogDetails:EmailLogDetails = new EmailLogDetails();
    jobId: number;
    printPreview: PrintPreviewModel;
    jobDetailMaster: JobDetailMaster;
    jobAppointMent: JobAppointMent;
    logo: Logo = new Logo();
    customerAndTechDetails: PrintPreview;
    jobDetailListTab: WoJobTaskDetails[] = [];
    specialInstruction: SpecialService[] = [];
    serviceNotes: SpecialService[] = [];
    technicianRemarksList: SpecialService[] = [];
    serviceNotesReason: any;
    specialInsstructionReason: any;
    displayName: string;
    company: Company = new Company();
    logoPrintout: Logo = new Logo();
    logoPrintoutHeader: Logo = new Logo();
    logoPrintoutFooter: Logo = new Logo();
    WoJobNo: string = "";
    partRequestEntity: PartRequestEntity[] = [];
    hoursStr: string;
    minStr: string;
    daysStr: string;
    woSLAhistory: WoSLAHistory[];
    woslahistory: WoSLAHistory;

    woJobId: number;
    CustomerId: number;
    TechId: number;
    WorkOrderId: number;
    frmEmailJob: FormGroup;
    submitted: boolean = false;
    isPreview: boolean = false;
    TechRemarks :any; // Added By Amalraj S 18Sep2018 Insight
    sigNature: SigNature[] = [];
    signaturecount:number;

    @Input() smsmsvalue: SmsLogReceived;
    smsdetails:any;
    constructor(protected sharedService: SharedService, protected translate: TranslateService,
        private _technicianJobService: TechnicianJobService, private datePipe: DatePipe, private loaderService: LoaderService, private formBuilder: FormBuilder) {
        super(sharedService, translate);       
        this.customerAndTechDetails = new PrintPreview();
        this.woslahistory = new WoSLAHistory();
    }

    ngOnInit() {
        debugger;
        this.smsdetails=this.smsmsvalue;
       this.createForm();
        this.companyId = this.globalInfo().CompanyId;
        // this.jobId = this.job.jobId;
        // this.woJobId = this.job.jobId;
        // this.WorkOrderId = this.job.woId;
        // this.TechId = this.job.techId;
        this.userId = super.globalInfo().LoginId;
     
        this.GetEmailLogValues();
        
    }

    GetEmailLogValues(){
debugger;
        // this._technicianJobService.GetEmailLogValues(this.LogId).subscribe(s => {
        //     debugger;
        //     this.emailLogDetails=s;

            this.frmEmailJob.controls['To'].setValue(this.smsdetails.ToNumber);
            this.frmEmailJob.controls['Subject'].setValue('');
          this.woJobId = this.smsdetails.wojobid;
           this.WorkOrderId = this.smsdetails.WorkOrderid;

      //  })

    }
    closeEmail() {
        this.done.emit(null);
    }

    createForm() {
        // this.frmEmailJob = this.formBuilder.group({
        //     CustomerName: ['', Validators.required],
        //     To: ['',  Validators.compose([Validators.required, multipleEmailValidator])],
        //     Subject: ['Email Job# - ' + this.job.jobId, Validators.required],
        //     Attachement: [''],
        //     Body: ['']
        // });

        this.frmEmailJob = this.formBuilder.group({
          
            To: [''],
            Subject: ['Email Job# - ' ],//+ this.job.jobId
            Body: ['']
        });
    }
    Send() {
        debugger;
        this.submitted = true;
        if (this.frmEmailJob.valid) {
            let innerContents: any = document.getElementById('mytext');
            let html =  innerContents.value ;
            let data: SendEmailJob = this.frmEmailJob.value;
            data.CompanyId = this.globalInfo().CompanyId + "";
            data.LoginId = this.globalInfo().LoginId + "";
            data.WoJobId = this.woJobId + "";
            data.WorkOrderId = this.WorkOrderId;
            //data.AttachementContent = html;
            data.Body=html;
            data.IsInvoice=0;
            data.InvoiceId="";
            this.loaderService.show();
            this._technicianJobService.SendEmailJob(data).subscribe(s => {
                this.loaderService.hide();
                let message = s.Message;
                if (message.Severity == 0)
                   // this.closeEmailPopup();
                this.sharedService.notification.emit({
                    severity: Severities[message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[message.Severity]),
                    detail: this.translate.instant(message.MessageCode)
                });
            },
                e => { this.loaderService.hide(); }
            );

        }
    }


    doPreview() {
        this.isPreview = true;
    }
    doBack() {
        this.isPreview = false;
    }

   

   

  
   

  
}